$(document).ready(function() {
  'use strict';

  ;(function($, window, document, undefined)
  {
    $('.file-upload').each( function()
    {
      var $input = $(this);
      var $label = $input.next( 'label' );
      var labelVal = $label.html();

      $input.on('change', function(e)
      {
        var fileName = '';

        if (this.files && this.files.length > 0) {
          fileName = 'Uploaded: ' + e.target.value.split( '\\' ).pop();
        }

        if (fileName) {
          $label.find('strong').html(fileName);
        }
        else {
          $label.html(labelVal);
        }
      });

      // Firefox bug fix
      $input
      .on('focus', function(){ $input.addClass('has-focus'); })
      .on('blur', function(){ $input.removeClass('has-focus'); });
    });
  })(jQuery, window, document);
});

$(document).ready(function () {
  const carousel = $('.js-carousel-horizontal');
  //make duplicate for infinite scroll
  const images = $('.js-carousel-images')
  const imagesWidth = images.width();
  const clone = images.clone();
  clone.removeClass();
  clone.addClass('js-carousel-images-clone carousel-images-clone u-fx');
  clone.insertAfter(images);
  //Get number of images to always have the same speed
  const nmbrOfImages = images.children().length;
  const widthBreakpoint = 992;

  function animation() {
    carousel.animate(
      { imagesWidth: imagesWidth }, {
        duration: nmbrOfImages * 3500,
        easing: 'linear',
        step: function (now, fx) {
          $(this).css('transform', 'translateX(-${' + now + '}px)');
        },
        done: function () {
          $(this).css('transform', 'translateX(0)');
          this.imagesWidth = 0;
          animation();
        },
      });

    if ($(window).width() < widthBreakpoint) {
      carousel.pause();
    }
  }

  animation();

  $(window).resize(function () {
    if ($(window).width() < widthBreakpoint) {
      carousel.pause();
    } else {
      carousel.resume();
    }
  });

  //On hover pause animation
  carousel.hover(
    function () {
      if ($(window).width() >= widthBreakpoint) {
        carousel.pause();
      }
    },
    function () {
      if ($(window).width() >= widthBreakpoint) {
        carousel.resume();
      }
    }
  );
});
